import React from "react";

const PoliticasDevolucion = () => {
  return (
    <div className="bg-gray-100 text-gray-800 py-10 px-5 sm:px-10 md:px-20 lg:px-40">
      <div className="bg-white border-2 border-GrisOscuro rounded-lg p-6">
        <h1 className="text-2xl md:text-3xl font-bold mb-6 text-center">
          Políticas de Devolución
        </h1>

        {/* Sección 1 */}
        <h2 className="text-xl font-bold mt-6 mb-4">1. Objeto y Alcance</h2>
        <p className="mb-4 text-justify">
          Las presentes Políticas de Devolución regulan las condiciones,
          procedimientos y excepciones aplicables a la devolución de productos
          adquiridos en Agroh. Estas políticas se aplican a todas las compras
          realizadas a través de nuestro sitio web oficial [URL de la tienda] o
          por medios directos de venta gestionados por nuestra empresa.
        </p>

        {/* Sección 2 */}
        <h2 className="text-xl font-bold mt-6 mb-4">
          2. Condiciones Generales para la Devolución de Productos
        </h2>
        <ul className="list-disc list-inside mb-4">
          <li>
            <strong>Estado del Producto:</strong> El artículo debe encontrarse
            en condiciones nuevas, sin haber sido utilizado, alterado ni
            abierto, y con su empaque original intacto.
          </li>
          <li>
            <strong>Plazo de Solicitud de Devolución:</strong> La solicitud debe
            realizarse dentro de un plazo de 5 días naturales a partir de la
            recepción.
          </li>
          <li>
            <strong>Autorización Previa:</strong> Todas las devoluciones deben
            ser autorizadas por nuestro Departamento de Atención al Cliente.
          </li>
        </ul>

        {/* Sección 3 */}
        <h2 className="text-xl font-bold mt-6 mb-4">
          3. Productos No Aceptables para Devolución
        </h2>
        <ul className="list-disc list-inside mb-4">
          <li>
            Productos abiertos, utilizados o con empaque manipulado.
          </li>
          <li>
            Productos cuya fecha de vencimiento haya expirado al momento de la
            solicitud.
          </li>
          <li>
            Productos adquiridos en promociones especiales, salvo defectos de
            fabricación.
          </li>
          <li>
            Electrónicos manipulados de forma inapropiada, contraviniendo las
            instrucciones del fabricante.
          </li>
        </ul>

        {/* Sección 4 */}
        <h2 className="text-xl font-bold mt-6 mb-4">
          4. Procedimiento para Solicitar una Devolución
        </h2>
        <ol className="list-decimal list-inside mb-4">
          <li>
            <strong>Notificación Inicial:</strong> Enviar solicitud a{" "}
            <strong>admin@agroh.info</strong> o a través del formulario de
            contacto.
          </li>
          <li>
            <strong>Evaluación:</strong> Nuestro equipo evaluará la solicitud.
          </li>
          <li>
            <strong>Instrucciones:</strong> Se enviarán detalles para proceder
            con el envío.
          </li>
        </ol>

        {/* Sección 5 */}
        <h2 className="text-xl font-bold mt-6 mb-4">
          5. Productos Defectuosos o Dañados Durante el Envío
        </h2>
        <p className="mb-4 text-justify">
          Si recibe un producto defectuoso o dañado, Agroh se compromete a
          reemplazarlo o emitir un reembolso total.
        </p>

        {/* Sección 6 */}
        <h2 className="text-xl font-bold mt-6 mb-4">6. Reembolsos</h2>
        <p className="mb-4 text-justify">
          Los reembolsos se procesarán tras la evaluación y aceptación de la
          devolución.
        </p>

        {/* Sección 7 */}
        <h2 className="text-xl font-bold mt-6 mb-4">7. Cambios de Producto</h2>
        <p className="mb-4 text-justify">
          Agroh no realiza cambios directos. Se debe devolver el producto y
          realizar una nueva compra.
        </p>

        {/* Sección 8 */}
        <h2 className="text-xl font-bold mt-6 mb-4">
          8. Excepciones a las Políticas de Devolución
        </h2>
        <p className="mb-4 text-justify">
          No se aceptarán devoluciones por mal uso del producto o compras en
          liquidación, salvo defectos de fabricación.
        </p>

        {/* Sección 9 */}
        <h2 className="text-xl font-bold mt-6 mb-4">
          9. Modificaciones a las Políticas de Devolución
        </h2>
        <p className="mb-4 text-justify">
          Agroh se reserva el derecho de modificar estas políticas en cualquier
          momento sin previo aviso.
        </p>

        {/* Sección 10 */}
        <h2 className="text-xl font-bold mt-6 mb-4">10. Contacto</h2>
        <p className="mb-4 text-justify">
          Para más información, contacte a nuestro equipo de atención.
        </p>
      </div>
    </div>
  );
};

export default PoliticasDevolucion;
